export default "__VITE_PUBLIC_ASSET__e4388cb6__"